import { render, staticRenderFns } from "./Glize.vue?vue&type=template&id=a61b1904&scoped=true&lang=pug"
import script from "./Glize.vue?vue&type=script&lang=js"
export * from "./Glize.vue?vue&type=script&lang=js"
import style0 from "./Glize.vue?vue&type=style&index=0&id=a61b1904&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61b1904",
  null
  
)

export default component.exports